export default "__VITE_ASSET__BUCBJQ3H__"